// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
img {
  position: relative;
  width: 300px;
}

tr {
  padding: 0;
}

td {
  padding: 0;
}

.card {
  padding-bottom: 6vh;
}

.meter_card {
  padding: 10px 15px;
}

.meter_card h4 {
  font-weight: inherit;
}

.mat-card-content {
  padding: 0;
  max-width: 100%;
}

.divider {
  border-right: 1.5px solid lightgrey;
  width: 150px;
  border-spacing: 0;
}

.meter_card button {
  background-color: #90CAFC;
  height: 30px;
  padding: 0;
  width: -moz-fit-content;
  width: fit-content;
}

.meter_card button span {
  position: relative;
}

.meter_type {
  color: black;
  font-size: 17px;
  font-weight: 100;
}

.iferror_message {
  position: relative;
  display: none;
  display: block;
  color: red;
  font-size: small;
  margin: 0em auto;
  padding: 1em;
  width: 60%;
  background-color: #fff; /* 背景色 */
  border: 1px solid #ccc; /* 枠線 */
  border-color: red;
}

.textarea_error {
  color: orange;
}

.detected_value {
  color: black;
  background-color: rgb(225, 242, 255);
  font-size: 12px;
}

.last_month_value {
  color: black;
  font-size: 20px;
  font-weight: 600;
}

.final_value {
  color: #3399FF;
  font-size: 20px;
  font-weight: 600;
}

.reading_failure {
  color: red;
  font-size: 20px;
  display: none;
  display: block;
}

.recheck_button_img {
  width: 20px;
}

.bookmark_img {
  width: 16px;
  margin-left: 1px;
  vertical-align: middle;
  cursor: pointer;
}

.qrcode_img {
  width: 25px;
  vertical-align: middle;
  cursor: pointer;
}

.content {
  display: flex;
  justify-content: space-between;
  max-width: 310px;
  margin: 0 auto;
  align-items: center;
}

.qrcode_edit_img {
  width: 25px;
  margin-left: 7px;
  vertical-align: middle;
  cursor: pointer;
}

::placeholder {
  font-size: 8px;
}

.notConfirm {
  background-color: gray;
}

.button-text {
  font-size: 8pt;
  padding: 3px;
}

.confirmed_report {
  color: darkolivegreen;
}

.meter-label {
  font-size: 14pt;
  font-weight: bold;
}

.last_month-date {
  font-size: 9pt;
  font-weight: lighter;
  color: #5a5a5a;
  padding-top: 2px;
}

.this_month-date {
  font-size: 9pt;
  font-weight: lighter;
  color: #5a5a5a;
}

.placeholder {
  size: 31px;
  width: 55%;
  margin: 0px 5px;
}

.edit-form {
  max-width: 100%;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/compornents/card/card.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACC,kBAAA;EACA,YAAA;AAED;;AACA;EACC,UAAA;AAED;;AACA;EACC,UAAA;AAED;;AACA;EACC,mBAAA;AAED;;AACA;EACC,kBAAA;AAED;;AACA;EACE,oBAAA;AAEF;;AACA;EACC,UAAA;EACA,eAAA;AAED;;AACA;EACC,mCAAA;EACA,YAAA;EACA,iBAAA;AAED;;AACA;EACC,yBAAA;EAEA,YAAA;EACA,UAAA;EACA,uBAAA;EAAA,kBAAA;AACD;;AACA;EACC,kBAAA;AAED;;AACA;EACC,YAAA;EACA,eAAA;EACA,gBAAA;AAED;;AAEA;EACC,kBAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACC,YAAA;EACA,UAAA;EACA,sBAAA,EAAA,QAAA;EACA,sBAAA,EAAA,OAAA;EACA,iBAAA;AACF;;AAEA;EACC,aAAA;AACD;;AAGA;EACC,YAAA;EACA,oCAAA;EACA,eAAA;AAAD;;AAGA;EACC,YAAA;EACA,eAAA;EACA,gBAAA;AAAD;;AAGA;EACC,cAAA;EACA,eAAA;EACA,gBAAA;AAAD;;AAIA;EACC,UAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AADD;;AAIA;EACC,WAAA;AADD;;AAIA;EACC,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AADD;;AAIA;EACC,WAAA;EACA,sBAAA;EACA,eAAA;AADD;;AAIA;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AADD;;AAIA;EACC,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AADD;;AAKA;EACC,cAAA;AAFD;;AAKA;EACC,sBAAA;AAFD;;AAKA;EACC,cAAA;EACA,YAAA;AAFD;;AAKA;EACC,qBAAA;AAFD;;AAKA;EACC,eAAA;EACA,iBAAA;AAFD;;AAKA;EACC,cAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;AAFD;;AAKA;EACC,cAAA;EACA,oBAAA;EACA,cAAA;AAFD;;AAKA;EACC,UAAA;EACA,UAAA;EACA,eAAA;AAFD;;AAKA;EACC,eAAA;EACA,mBAAA;AAFD","sourcesContent":["img{\n\tposition: relative;\n\twidth: 300px;\n}\n\ntr {\n\tpadding: 0;\n}\n\ntd {\n\tpadding: 0;\n}\n\n.card {\n\tpadding-bottom: 6vh;//footerと同じ高さにすることでコンテンツと被らなくなる\n}\n\n.meter_card {\n\tpadding: 10px 15px;\n}\n\n.meter_card h4{\n  font-weight: inherit;\n}\n\n.mat-card-content{\n\tpadding: 0;\n\tmax-width: 100%;\n}\n\n.divider {\n\tborder-right: 1.5px solid lightgrey;\n\twidth: 150px;\n\tborder-spacing: 0;\n}\n\n.meter_card button{\n\tbackground-color: #90CAFC;\n\t// margin: 0 5px 0 0;\n\theight: 30px;\n\tpadding: 0;\n\twidth: fit-content;\n}\n.meter_card button span{\n\tposition: relative;\n}\n\n.meter_type{\n\tcolor:black;\n\tfont-size: 17px;\n\tfont-weight: 100;\n}\n\n//検針値未確定\n.iferror_message{\n\tposition: relative;\n\tdisplay:none;//正常処理なら非表示\n\tdisplay:block;//エラーなら表示\n\tcolor: red;\n\tfont-size: small;//0915追加\n\tmargin: 0em auto;\n \tpadding: 1em;\n \twidth: 60%;//0915変更\n \tbackground-color: #fff; /* 背景色 */\n \tborder: 1px solid #ccc; /* 枠線 */\n \tborder-color: red;\n}\n//検針値を数値で入力してくださいメッセージ\n.textarea_error{\n\tcolor:orange;\n}\n\n//解析値表示\n.detected_value{\n\tcolor:black;\n\tbackground-color:rgb(225, 242, 255);\n\tfont-size: 12px;\n}\n//確定値表示\n.last_month_value{\n\tcolor: black;\n\tfont-size: 20px;\n\tfont-weight: 600;\n}\n\n.final_value{\n\tcolor: #3399FF;\n\tfont-size: 20px;\n\tfont-weight: 600;\n}\n\n//読取失敗\n.reading_failure{\n\tcolor: red;\n\tfont-size: 20px;\n\tdisplay:none;//正常処理なら非表示\n\tdisplay:block;//エラーなら表示\n}\n\n.recheck_button_img{\n\twidth: 20px;\n}\n\n.bookmark_img{\n\twidth: 16px;\n\tmargin-left: 1px;\n\tvertical-align: middle;\n\tcursor:pointer;\n}\n\n.qrcode_img{\n\twidth: 25px;\n\tvertical-align: middle;\n\tcursor:pointer;\n}\n\n.content {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmax-width: 310px;\n\tmargin: 0 auto;\n\talign-items: center;//上下の配置の指定（中央）\n  }\n\n.qrcode_edit_img{\n\twidth: 25px;\n\tmargin-left: 7px;\n\tvertical-align: middle;\n\tcursor:pointer;\n}\n\n\n::placeholder{\n\tfont-size: 8px;\n}\n\n.notConfirm {\n\tbackground-color: gray;\n}\n\n.button-text{\n\tfont-size: 8pt;\n\tpadding: 3px;\n}\n\n.confirmed_report{\n\tcolor: darkolivegreen;\n}\n\n.meter-label{\n\tfont-size: 14pt;\n\tfont-weight: bold;\n}\n\n.last_month-date{\n\tfont-size: 9pt;\n\tfont-weight: lighter;\n\tcolor: #5a5a5a;\n\tpadding-top: 2px;\n}\n\n.this_month-date{\n\tfont-size: 9pt;\n\tfont-weight: lighter;\n\tcolor: #5a5a5a;\n}\n\n.placeholder{\n\tsize: 31px;\n\twidth: 55%;\n\tmargin: 0px 5px;\n}\n\n.edit-form {\n\tmax-width: 100%;\n\twhite-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
